import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=b563d3d6&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&id=b563d3d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b563d3d6",
  null
  
)

export default component.exports